import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTableComponent } from './components/data-table/data-table.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { MsgPopupComponent } from './components/msg-popup/msg-popup.component';
import { QuillModule } from 'ngx-quill';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DataTableComponent,
    PaginationComponent,
    MsgPopupComponent,
    QuillModule.forRoot()
  ],
  exports: [
    FormsModule,
    DataTableComponent,
    PaginationComponent,
    MsgPopupComponent,
    QuillModule
  ]
})
export class SharedModule { }
